import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppService } from '../../../services/app.service';
import { UtilsService } from '../../../services/utils.service';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/users.service';
import { VirtualCardsService } from '../../../services/virtual_cards.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PaymentDeclarationsService } from '../../../services/payment_declarations.service';

@Component({
  selector: 'app-view-wallets-to-deposit',
  templateUrl: './view-wallets-to-deposit.component.html',
  styleUrl: './view-wallets-to-deposit.component.scss',
})
export class ViewWalletsToDepositComponent {
  @Input() type: any = null;
  @Input() amount: any = null;
  @Input() currency: any = null;
  @Input() token: any = [];

  currencyType: any;

  selectedToken: any = null;
  wallets: any;
  showWallets = false;
  walletList: any[] = [];

  constructor(
    private cardsService: VirtualCardsService,
    private formBuilder: FormBuilder,
    public utilsService: UtilsService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public auth: AuthService,
    public appService: AppService,
    public userService: UserService,
    private sanitizer: DomSanitizer,
    private paymentDeclaration: PaymentDeclarationsService,
  ) {}

  ngOnInit() {
    this.showWallets = true;

    this.currencyType = this.utilsService.getCurrencyKind(
      this.currency,
      this.appService.config?.currencies,
    );
    this.setVirtualCardTokens();
  }

  setVirtualCardTokens() {
    if (this.type === 'virtual_card') {
      let card = this.token;

      this.wallets = card.tokens;
      this.wallets.forEach((el: any) => {
        el.address = card.address;
      });
    } else {
      this.wallets = this.token;
      this.selectedToken = this.token;
    }

    this.walletList = Array.isArray(this.wallets)
      ? this.wallets
      : this.wallets
        ? [this.wallets]
        : [];
  }

  exitView() {
    this.appService.triggerViewWallets(false);
  }

  selectToken(token: any) {
    if (this.type !== 'virtual_card') {
      this.selectedToken = token;
      this.toggleShowDeclarePayment();
    }
  }

  toggleShowDeclarePayment() {
    this.appService.triggerAddPayment(
      true,
      this.selectedToken.blockchain,
      this.selectedToken.symbol,
      this.type,
      this.amount,
      this.selectedToken.wallet,
    );
  }

  copy(text: any, event: any) {
    event.stopPropagation();
    event.preventDefault();

    this.utilsService.copyToClipboard(text);
  }
}
